module.exports = __webpack_public_path__ + "img/logo.0f1e6e28.png";